import React from 'react';
import { useLang } from '../context/LanguageContext';
import { PageHeader } from '../components/PageHeader';
import ContactStrip from '../components/ContactStrip';
import SEO from '../components/SEO';
import { SEO_KEYWORDS } from '../data/seo';
import Breadcrumbs from '../components/geo/Breadcrumbs';
import AuthorMeta from '../components/geo/AuthorMeta';
import RelatedTopics from '../components/geo/RelatedTopics';
import { SITE_URL, CONTACT } from '../data/site';

const DE = {
  label: 'Fachredaktion', title: 'Fachredaktion & Expertise',
  lead: 'Die fachliche Verantwortung für die Inhalte von metakaolin.info liegt bei der NEWCHEM GmbH.',
  blocks: [
    { h: 'Technische Kompetenz von Newchem', p: 'NEWCHEM GmbH ist ein unabhängiger Spezialist für mineralische Zusatzstoffe und Bindemittelsysteme mit langjähriger Erfahrung in Auswahl, Bewertung und anwendungsspezifischer Prüfung für die Beton-, Fertigteil- und Trockenmörtelindustrie.' },
    { h: 'Erfahrung mit mineralischen Zusatzstoffen', p: 'Der fachliche Fokus liegt auf puzzolanischen und latent-hydraulischen Zusatzstoffen, deren Wirkung auf Reaktivität, Festigkeitsentwicklung, Gefügedichte und Dauerhaftigkeit – stets bezogen auf das konkrete Bindemittelsystem.' },
    { h: 'Verfahren zur fachlichen Prüfung', p: 'Inhalte werden vor Veröffentlichung fachlich geprüft. Technische Aussagen werden auf Korrektheit, Kontextualisierung und Nachvollziehbarkeit geprüft; Versuchsdaten werden mit Methodik und Randbedingungen ausgewiesen und in definierten Abständen überprüft.' },
    { h: 'Trennung von Fachinformation und Produktberatung', p: 'Allgemeines Fachwissen wird klar von Produktberatung getrennt. Für verbindliche, projektspezifische Empfehlungen ist eine individuelle technische Beratung erforderlich.' },
  ],
};
const EN = {
  label: 'Editorial team', title: 'Editorial team & expertise',
  lead: 'Technical responsibility for the content of metakaolin.info lies with NEWCHEM GmbH.',
  blocks: [
    { h: 'Technical competence of Newchem', p: 'NEWCHEM GmbH is an independent specialist for mineral additions and binder systems with many years of experience in selection, evaluation and application-specific testing for the concrete, precast and dry-mortar industries.' },
    { h: 'Experience with mineral additions', p: 'The technical focus is on pozzolanic and latent-hydraulic additions and their effect on reactivity, strength development, matrix density and durability – always in relation to the specific binder system.' },
    { h: 'Technical review process', p: 'Content is technically reviewed before publication. Technical statements are checked for correctness, contextualisation and traceability; test data are reported with methodology and boundary conditions and reviewed at defined intervals.' },
    { h: 'Separation of information and product advice', p: 'General technical knowledge is clearly separated from product advice. For binding, project-specific recommendations, individual technical consultation is required.' },
  ],
};

const Fachredaktion = () => {
  const { lang } = useLang();
  const d = lang === 'de' ? DE : EN;
  const jsonLd = {
    '@context': 'https://schema.org', '@type': 'WebPage',
    name: d.title, description: d.lead, inLanguage: lang,
    mainEntityOfPage: `${SITE_URL}/fachredaktion`,
    publisher: { '@type': 'Organization', name: 'NEWCHEM GmbH', url: CONTACT.website },
  };
  return (
    <div>
      <SEO title={d.title} description={d.lead} path="/fachredaktion" lang={lang} keywords={SEO_KEYWORDS[lang]} jsonLd={jsonLd} />
      <PageHeader label={d.label} title={d.title} lead={d.lead} imageKey="labTest1" />
      <section className="bg-white py-14 lg:py-20">
        <div className="container-wide">
          <Breadcrumbs items={[{ label: d.label, to: '/fachredaktion' }]} />
          <div className="mt-8 max-w-2xl space-y-10">
            {d.blocks.map((b, i) => (
              <div key={i}>
                <h2 className="text-[22px] font-extrabold tracking-tight text-slate-900">{b.h}</h2>
                <p className="mt-3 text-[15px] text-slate-600 leading-relaxed">{b.p}</p>
              </div>
            ))}
            <AuthorMeta dates={{ published: '2025-07-01', reviewed: '2025-07-16' }} />
            <RelatedTopics items={[
              { de: 'Über metakaolin.info', en: 'About metakaolin.info', to: '/ueber-metakaolin-info' },
              { de: 'Newchem Kompetenz', en: 'Newchem competence', to: '/newchem-kompetenz' },
              { de: 'Kontakt', en: 'Contact', to: '/contact' },
            ]} />
          </div>
        </div>
      </section>
      <ContactStrip />
    </div>
  );
};

export default Fachredaktion;
